export const sortByNameKey = (a, b, key) => {
  return a[key].localeCompare(b[key])
}

export const sortByKey = (a, b, key) => {
  if (a[key] > b[key]) return 1
  if (a[key] < b[key]) return -1
  return 0
}

export const sortByKeyReverse = (a, b, key) => {
  if (a[key] > b[key]) return -1
  if (a[key] < b[key]) return 1
  return 0
}

export const sortByBooleanKey = (a, b, key) => {
  return (a[key] === b[key]) ? 0 : a[key] ? -1 : 1
}

// Use to sort an array by key value and an order between ASC and DESC
export const sortArrayByKeyAndOrder = (arrayToSort, sortKey, sortOrder) => {
  if (arrayToSort !== null && arrayToSort !== undefined) {
    arrayToSort = arrayToSort.sort((a, b) => {
      if (sortOrder === 'ASC') {
        return a[sortKey] - b[sortKey]
      } else if (sortOrder === 'DESC') {
        return b[sortKey] - a[sortKey]
      }
    })
    return arrayToSort
  } else {
    return []
  }
}

export const sortByLabel = (a, b) => (a.label > b.label) ? 1 : -1

export default {
  sortArrayByKeyAndOrder,
  sortByLabel,
}
